import { type SxProps, type Theme } from "@mui/material";
import helpboxImage from "@repo/ui/assets/images/helpbox.png";
import { type FC } from "react";
import { InternalLink } from "../InternalLink";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import * as Styled from "./Homepage.styled";

type HomepageHelpBoxProps = {
    noImage?: boolean;
    sx?: SxProps<Theme>;
};

export const HelpBox: FC<HomepageHelpBoxProps> = ({ noImage = false, sx }) => {
    const { t } = useTypedTranslation();
    return (
        <Styled.HelpOverview
            noImage={noImage}
            sx={sx}
            image={!noImage ? helpboxImage : undefined}
        >
            <Styled.HelpAlert
                severity={undefined}
                icon={<Styled.HelpIcon />}
            >
                <Styled.HelpHeading scaleDown>
                    {t("global.personsOnContract.bannerTitle")}
                </Styled.HelpHeading>
                <Styled.HelpBodyText>{t("global.personsOnContract.bannerText")}</Styled.HelpBodyText>
                <InternalLink href="/kontakty/">{t("global.personsOnContract.bannerButton")}</InternalLink>
            </Styled.HelpAlert>
        </Styled.HelpOverview>
    );
};
